import { useLanguage } from "@/context/LanguageContext";

/**
 * Discreet transparency note about AI-generated / AI-edited imagery.
 * Sits directly below the Gallery. Deliberately kept low-key: soft neutral
 * background, small typography, no icons or CTAs.
 */
export const AiImageNote = () => {
  const { t } = useLanguage();
  if (!t.aiNote) return null;

  const paragraphs = t.aiNote.body.split("\n").filter(Boolean);

  return (
    <section
      data-testid="ai-image-note-section"
      className="pb-16 md:pb-24 bg-white"
    >
      <div className="max-w-4xl mx-auto px-5 md:px-10">
        <div
          data-testid="ai-image-note"
          className="rounded-2xl bg-[#F8FAFC] border border-slate-200/70 px-5 py-5 md:px-7 md:py-6"
        >
          <div className="text-[10px] md:text-[11px] uppercase tracking-[0.22em] font-semibold text-neutral-500">
            {t.aiNote.title}
          </div>
          <div className="mt-2 space-y-2">
            {paragraphs.map((p, i) => (
              <p
                key={i}
                className="text-[13px] md:text-sm leading-relaxed text-neutral-600"
              >
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiImageNote;
